import { useAlert } from "capitalrx-components-2.0/lib/general";
import { useRequestDiscountCardMutation } from "@/api/getAdvantageCard";
import { CloseModalProp } from "@/api/interfaces/AdvantageCardRequest";
import { useGroupNumber } from "@/utils/useGroupNumber";
import { WhiteLabelSubmit } from "@/components/WhiteLabelComponents";
import { Paragraph } from "capitalrx-components-2.0/lib/typography";
import { Form } from "capitalrx-components-2.0/lib/forms";

import styles from "../styles.module.scss";

const PrintModal = (props: CloseModalProp): JSX.Element => {
  const { onClose } = props;

  const showAlert = useAlert();
  const [requestCard] = useRequestDiscountCardMutation();

  const group_number = useGroupNumber();

  const handleSubmit = async (): Promise<void> => {
    await requestCard({
      request_type: 1,
      recipient: "",
      group_number: group_number,
    })
      .unwrap()
      .then((data) => window.open(data.print_url, "_blank"))
      .catch((data) =>
        showAlert({ message: "Failed to print card. Please try again or contact customer support.", type: "error", style: "toast" }),
      );

    onClose();
  };

  return (
    <Form className={styles.ModalForm} onSubmit={handleSubmit}>
      <Paragraph className={styles.ModalFormTitle} textAlign="center">Print Discount Card</Paragraph>
      <Paragraph className={styles.ModalFormSubTitle} textAlign="center">Click below to open a new tab to print the discount card.</Paragraph>
      <WhiteLabelSubmit text="Print Card" />
    </Form>
  );
};

export default PrintModal;
